import { render, staticRenderFns } from "./ShelterLayer.vue?vue&type=template&id=6f5e5989&"
import script from "./ShelterLayer.vue?vue&type=script&lang=js&"
export * from "./ShelterLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports